var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3083_14463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1457 8.20459L14.519 6.34459L14.7457 3.88459L12.339 3.33792L11.079 1.20459L8.81234 2.17792L6.54567 1.20459L5.28567 3.33126L2.879 3.87126L3.10567 6.33792L1.479 8.20459L3.10567 10.0646L2.879 12.5313L5.28567 13.0779L6.54567 15.2046L8.81234 14.2246L11.079 15.1979L12.339 13.0713L14.7457 12.5246L14.519 10.0646L16.1457 8.20459ZM7.06567 10.8779L5.479 9.27792C5.219 9.01792 5.219 8.59792 5.479 8.33792L5.52567 8.29126C5.78567 8.03126 6.21234 8.03126 6.47234 8.29126L7.54567 9.37126L10.979 5.93126C11.239 5.67126 11.6657 5.67126 11.9257 5.93126L11.9723 5.97792C12.2323 6.23792 12.2323 6.65792 11.9723 6.91792L8.02567 10.8779C7.75234 11.1379 7.33234 11.1379 7.06567 10.8779Z",
    fill: "#8139D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3083_14463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.8125 0.20459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.59fd55eccd057f3de3c13327ab06409f.svg";
export { ForwardRef as ReactComponent };